import { Box, Card, CardMedia, Typography } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';
import SignUpOnboardingStep from './SignUpOnboardingStep';
import Logo from '../../images/logo.png';
import useStore from '../../Store/Store';
import CAN from '../../images/can.svg';
import AppleHealth from '../../images/appleHealth.svg';
import GoogleFit from '../../images/googleFit.svg';
import AddDeviceModal from './AddDeviceModal';
import { getUserInfo, pairDeviceApi, updateUserInfo } from '../../utils/api';
import { useMutation, useQuery } from 'react-query';
import { isEmpty } from 'lodash';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Avatar } from '@mui/material';
import inputValidationService from '../../input-validation.service';
import Button from '../../components/Button';

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#f7f7f7',
  borderRadius: '16px',
  display: 'flex',
  justifyContent: 'space-between',
  padding: 8,
  marginBottom: 2,
  boxShadow: 'none',
}));

const StyledCardMedia = styled(CardMedia)({
  width: '60px',
  height: '60px',
  borderRadius: '16px',
  overflow: 'hidden',
  border: '1px solid rgba(229, 229, 234, 1)',
  objectFit: 'contain',
  backgroundColor: '#fff',
});

const SOURCE_LIST = [
  {
    title: 'CAN Go',
    img: CAN,
    download: false,
  },
  {
    title: 'Apple Health',
    img: AppleHealth,
    download: true,
  },
  {
    title: 'Google Fit',
    img: GoogleFit,
    download: true,
  },
];

const DeviceIntegration = ({ handleBackStep, handleNextStep, loader }) => {
  const width = useStore((state) => state.screenWidth);
  const [deviceModal, setDeviceModal] = React.useState(false);
  const [deviceConnected, setDeviceConnected] = React.useState(false);
  const [error, setError] = React.useState('');

  const handleRedirectApp = () => {
    window.open('https://can.co/');
  };

  const { data: userData, refetch } = useQuery(['getUserInfo'], () => getUserInfo({ userId: null }), {
    retry: false,
    cacheTime: 0,
  });

  const updateUserInfoHandler = useMutation(updateUserInfo, {
    onSuccess: async ({ data }) => {},
    onError: (error) => {
      console.log('error =====> ', error);
      if (error?.response?.status === 400) {
        return setError(error?.response?.data?.data?.join(','));
      } else {
        return setError(error?.response?.data?.message || 'Something went wrong!');
      }
    },
  });

  const pairDevicehandler = useMutation(pairDeviceApi, {
    onSuccess: async ({ data }) => {
      setDeviceModal(false);
      setDeviceConnected(true);
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setError(error?.response?.data?.message || 'Something went wrong!');
    },
  });

  const handlePairDevice = (data) => {
    const { name, birthday, phoneNo, pin, height, weight } = data;
    const [firstName, lastName] = name?.split(' ');
    if (isEmpty(firstName)) {
      return setError('First Name cannot be empty');
    }
    if (isEmpty(lastName)) {
      return setError('Last Name cannot be empty');
    }
    if (isEmpty(birthday)) {
      return setError('Birth date cannot be empty');
    }
    if (isEmpty(pin)) {
      return setError('Pin cannot be empty');
    }
    if (isEmpty(weight)) {
      return setError('weight cannot be empty');
    }
    if (isEmpty(height)) {
      return setError('height cannot be empty');
    }
    if (isEmpty(phoneNo) || !inputValidationService.validatePhoneNumber(phoneNo)) {
      return setError('Phone is not valid');
    }

    setError('');

    updateUserInfoHandler.mutate({
      body: { dob: birthday, phoneNo, firstName, lastName, weight, height },
    });
    pairDevicehandler.mutate({ pin });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: width > 1050 ? '50%' : '100%',
        padding: '1rem',
      }}
    >
      <Box
        component="img"
        sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
        alt="Mask group"
        src={Logo}
      />
      <div style={{ paddingInline: '4rem', paddingBlock: '5rem' }}>
        <SignUpOnboardingStep step={4} total={4} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <Typography
              variant="h4"
              sx={{
                fontFamily: "'Inter-Medium', Helvetica",
                fontWeight: 'medium',
                color: 'rgba(29, 29, 31, 1)',
              }}
            >
              Connect your devices
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {SOURCE_LIST.map((item) => (
                <StyledCard>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    <StyledCardMedia component="img" image={item.img} alt="Apple Health" />
                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: "'Roboto', Helvetica",
                        fontWeight: 500,
                        color: 'rgba(29, 29, 31, 1)',
                      }}
                    >
                      {item?.title}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    {item.download ? (
                      <Button bg="ligth" onClick={handleRedirectApp} text="Download" />
                    ) : (
                      <>
                        {deviceConnected ? (
                          <Box
                            display="inline-flex"
                            alignItems="center"
                            justifyContent="center"
                            gap={1}
                            px={3}
                            py={1}
                            bgcolor="rgba(244, 250, 236, 1)"
                            borderRadius="100px"
                          >
                            <Avatar
                              sx={{
                                bgcolor: 'rgba(140, 208, 60, 1)',
                                width: 24,
                                height: 24,
                              }}
                            >
                              <CheckCircleIcon sx={{ color: 'white', width: 16, height: 16 }} />
                            </Avatar>
                            <Typography
                              variant="body1"
                              sx={{
                                fontFamily: 'Roboto, Helvetica',
                                fontWeight: 400,
                                fontSize: 14,
                                color: 'rgba(29, 29, 31, 1)',
                              }}
                            >
                              Connected
                            </Typography>
                          </Box>
                        ) : (
                          <Button text="Connect" onClick={() => setDeviceModal(true)} />
                        )}
                      </>
                    )}
                  </Box>
                </StyledCard>
              ))}
            </Box>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 6, marginTop: '40px' }}>
          <Button onClick={handleBackStep} text="Back" bg="light" fullWidth />
          <Button onClick={handleNextStep} text="Next" loading={loader} fullWidth />
        </Box>
      </div>
      {/* <Typography variant="subtitle1" style={{ color: 'red', marginTop: '-30px' }} textAlign="center">
        {errorMessage}
      </Typography> */}
      <AddDeviceModal
        show={deviceModal}
        onClose={() => setDeviceModal(false)}
        userData={userData}
        handlePairDevice={handlePairDevice}
        error={error}
        loader={pairDevicehandler.isLoading}
      />
    </Box>
  );
};

export default DeviceIntegration;
